import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerCognitoSubmit = props => {
  const datalayerCognitoFormSubmitHandler = event => {
    const validClasses = ["cog-button--submit", "cog-button__text"]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      const header = document?.querySelectorAll(".t2-layout-form__header") || document?.querySelectorAll(".formTopContent__header") || document.querySelectorAll(".cog-heading")
      const form_name = header.length > 0 ? header[0]?.innerText : null
      const form_id = props?.data?.contentfulPageGeneral?.sections?.find((element) => element?.formReference != null )?.formReference[0]?.formId || null;
      window.dataLayer = window.dataLayer || []
      let data = {
        event: "form_submit_success",
        form_type: "cognito_form",
        form_name: form_name,
        cognito_form: form_id,
      }
      if (document?.querySelectorAll(".cog-confirmation").length > 0) {
        data = {
          event: "form_submit_success",
          form_type: "cognito_form",
          form_name: form_name,
          cognito_form: form_id,
          form_leadsource: "Webform - Content",
        }
      }
      if (!document?.querySelectorAll(".cog-error-message").length > 0) {
        window.dataLayer.push(data)
      }
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".t2-layout-form").length > 0
  }
  useClickListener(datalayerCognitoFormSubmitHandler, query)
}

export default DatalayerCognitoSubmit
